<template>
  <div>
    <filtersToggleBadge
      
      :category="category"
      :enabled="true"
      :show-remove="false"
      :interactive="false"
      @_mouseover="($event) => showTooltip($event)"
      @_mouseleave="hideTooltip()"
    />
    <ClientOnly>
      <template v-if="tooltip.tooltipPosition.value.owner === tooltipId">
        <Teleport to="#teleport-header"> {{ category.toUpperCase() }}</Teleport>
        <Teleport to="#teleport-content">
          {{ categoryDefinition }}
        </Teleport>
      </template>
    </ClientOnly>
  </div>
</template>

<script setup>
import { useTooltip } from "@/composables/useTooltip.js";
import categoriesDefinition from "@/assets/categories.json";
const tooltipId  = computed(() => {
    return props.parentId + "help-tooltip " + props.category;
})
const tooltip = useTooltip();

const props = defineProps({
  

  category: {
    type: String,
    default: "",
  },
  parentId: {
    type: String,
    default: "",
  },
});

const categoryDefinition = computed(() => {
  return categoriesDefinition.find((c) => c.name === props.category)?.description;
});

const showTooltip = (event) => {
    
    
  tooltip.show(event.pageX, event.pageY, tooltipId.value);
};

const hideTooltip = () => {
  tooltip.hide();
};
</script>

<style lang="scss" scoped></style>
